

















import { Prop, Component, Vue } from 'vue-property-decorator'
import ChallengeCell from './ChallengeCell.vue'
import Challenge from '../interfaces/challenge'
import Game from '../classes/game'
import { Challenges } from '../constants'

interface ChallengeType {
  name: string;
  rules: Challenge[];
}

@Component({
  components: {
    ChallengeCell
  }
})
export default class ChallengeBox extends Vue {
  @Prop() private navigator!: Record<string, string>;
  @Prop() private permanant!: Record<string, number>;
  @Prop() private game!: Game;

  get anyRunning () {
    return this.game.challengeStats.some((data) => {
      return data.isActive
    })
  }

  get challenges () {
    return Challenges
  }
}

